import PaymentSubmit from './PaymentSubmit';
export { PaymentSubmit };
export default PaymentSubmit;
